import { Uuid } from "@/domains/global/identifiers";
import { resolveSyncModelNamespacedUuid } from "@/modules/uuid/sync-models/resolveSyncModelNamespacedUuid";
import { SyncModelKind } from "@/store/sync/types";

export const resolveSpaceAccountCollectionSyncModelUuid = ({
  spaceAccountId,
  collectionId,
}: {
  spaceAccountId: Uuid;
  collectionId: Uuid;
}): Uuid => {
  return resolveSyncModelNamespacedUuid({
    modelKind: { value: SyncModelKind.SpaceAccountCollection },
    uuids: [spaceAccountId, collectionId],
  });
};
